import { Link, useParams } from "react-router-dom";
import EditAdminMessage from "./EditAdminMessage";
import { useGetAdminMessageByIdQuery } from "../../../../reactQueries/AppApi/rqHooksForAdminMessages";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";

const EditAdminMessageHome = () => {
  let { Id } = useParams();

  /**API calls */
  const {
    isSuccess,
    isFetching,
    error,
    data: adminMessageDataById,
    isError,
    isFetched,
  } = useGetAdminMessageByIdQuery({ Id });

  return (
    <div>
      {(!!isFetching) && "Wait, Loading...."}

      {!!isSuccess && (
        <EditAdminMessage adminMessageDataById={adminMessageDataById} />
      )}

      <MpgErrorDialog
        open={!!isError}
      />
    </div>
  );
};
export default EditAdminMessageHome;
